import { render, staticRenderFns } from "./financeWealthWayCategoryList.vue?vue&type=template&id=5457501e&scoped=true&"
import script from "./financeWealthWayCategoryList.vue?vue&type=script&lang=ts&"
export * from "./financeWealthWayCategoryList.vue?vue&type=script&lang=ts&"
import style0 from "./financeWealthWayCategoryList.vue?vue&type=style&index=0&id=5457501e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5457501e",
  null
  
)

export default component.exports